module.exports = __webpack_public_path__ + "static/media/light-ceiling.f03412be.svg";